import { render, staticRenderFns } from "./NestedRoute.vue?vue&type=template&id=11b227bd"
import script from "./NestedRoute.vue?vue&type=script&lang=js"
export * from "./NestedRoute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3254644805/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11b227bd')) {
      api.createRecord('11b227bd', component.options)
    } else {
      api.reload('11b227bd', component.options)
    }
    module.hot.accept("./NestedRoute.vue?vue&type=template&id=11b227bd", function () {
      api.rerender('11b227bd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Layout/NestedRoute.vue"
export default component.exports